import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import {
  getAllHotelRoomsQueryOptions,
  getHotelRoomQueryOptions,
  getHotelRoomsQueryOptions,
} from "./get.hooks";

export function useDeleteHotelRoom(
  hotelId: string,
  opts?: {
    onSuccess?: () => void;
    onError?: () => void;
  },
) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) =>
      api.delete<void>(`/api/hotel-rooms/$id`, undefined, {
        pathReplace: { $id: id },
      }),
    onSuccess: (_, id) => {
      queryClient.setQueryData(
        getHotelRoomsQueryOptions(hotelId).queryKey,
        (old) => old?.filter((r) => r.id !== id),
      );
      queryClient.setQueryData(getAllHotelRoomsQueryOptions.queryKey, (old) =>
        old?.filter((r) => r.id !== id),
      );
      queryClient.resetQueries({
        queryKey: getHotelRoomQueryOptions(hotelId, id).queryKey,
      });
      toast({
        title: "toast.hotelRoomDeleted",
        variant: "success",
      });
      opts?.onSuccess?.();
    },
    onError: () => {
      toast({
        title: "toast.hotelRoomError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
